export default function SuitableCompanies() {
  const industries = [
    { icon: 'ri-building-2-line', title: 'Производство', desc: 'Продажи сложных продуктов, длинный цикл сделки, работа с технарями' },
    { icon: 'ri-briefcase-4-line', title: 'B2B-компании', desc: 'Корпоративные продажи, тендеры, многоуровневые переговоры, LTV' },
    { icon: 'ri-code-s-slash-line', title: 'IT и разработка', desc: 'Продажа услуг и продуктов, работа с закупщиками, презентация ценности' },
    { icon: 'ri-truck-line', title: 'Дистрибьюторы', desc: 'Работа с дилерской сетью, управление территорией, развитие партнёров' },
    { icon: 'ri-ship-2-line', title: 'Логистика', desc: 'Комплексные логистические услуги, таможня, переговоры о тарифах' },
    { icon: 'ri-bank-line', title: 'Финансовый сектор', desc: 'Продажа финансовых продуктов, работа с возражениями, доверие клиента' },
    { icon: 'ri-home-8-line', title: 'Строительство', desc: 'Проектные продажи, работа с архитекторами и подрядчиками, тендеры' },
    { icon: 'ri-service-line', title: 'Услуги B2B/B2C', desc: 'Консалтинг, маркетинг, HR-услуги — продажа экспертизы и нематериальных продуктов' },
    { icon: 'ri-store-2-line', title: 'Розница', desc: 'Розничные сети, работа торгового персонала, стандарты обслуживания' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Для каких компаний подходит
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Обучение отдела продаж эффективно для компаний любого размера и отрасли. Программа адаптируется под вашу специфику.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {industries.map((industry, i) => (
            <div key={i} className="bg-white p-6 rounded-xl hover:ring-2 hover:ring-teal-200 transition-all group flex items-start gap-4">
              <div className="w-11 h-11 bg-teal-600 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
                <i className={`${industry.icon} text-lg text-white`}></i>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1.5 text-sm">{industry.title}</h3>
                <p className="text-gray-600 text-xs leading-relaxed">{industry.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}